<br>

<div  *ngIf="type === 'error'">
<div class="col-md-12" *ngFor="let e of errorlist">
  <p>- {{e}}</p>

  <br>

</div>
</div>

<div *ngIf="type==='passwordchanged'" class="col-md-12">
  Ditt lösenord är nu ändrat. Klicka på Fortsätt för att komma till inloggningen.
  <br><br>
</div>
<span *ngIf="type === 'passwordchanged'">
  <button class="btn border" (click)="continue()">Fortsätt</button>
  <button class="btn border" style="margin-left:20px;"  (click)="cancel()">Avbryt</button>
</span>
<button *ngIf="type === 'error'" class="btn border" (click)="cancel()">Avbryt Error</button>
